<template>
  <div class="detail">
    <div class="main" v-if="dataSource.title">
      <div class="title">{{dataSource.title}}</div>
      <div class="desc">{{dataSource.summary}}</div>
      <div class="content" v-html="dataSource.content"></div>
    </div>
    <Empty
      class="main"
      v-else
      :icon="
        'https://gt-toolbox.oss-cn-beijing.aliyuncs.com/gt-toolbox/229c3bef-a6ce-4c11-8727-7d34b505e454.png'
      "
      :message="msg"
    />
  </div>
</template>
<script>
import Empty from '@/components/Empty'
export default {
  props: {
    dataSource: {
      type: Object,
      default: {}
    },
    msg: {
      type: String,
      default: ''
    }
  },
  components: {
    Empty
  }
}
</script>

<style lang="less" scoped>
.detail {
  width: 1200px;
  min-height: 472px;
  border-radius: 2px;
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: 1px;
  padding-bottom: 1px;
  .main {
    background-color: #fff;
    min-height: 472px;
    padding: 32px 40px;
    box-sizing: border-box;
    margin: 24px 0;
    border-radius: 4px;
    .desc {
      margin-bottom: 24px;
      line-height: 24px;
      font-size: 12px;
      margin-top: 24px;
      color: #666666;
    }
    .content{
      word-break: break-all;
      line-height: 28px;
     /deep/ img{
        max-width: 100% !important;
      }
    }
  }
  .title {
    font-size: 24px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 36px;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home/components/Detail/index.vue